import {message} from "antd";

export function onInfo(text) {
    message.info(text);
}
